export default class dataList {
    static homePage() {
        return {
            title: 'JORNAY PM (methylphenidate HCI) for ADHD Treatment',
            /*titleTemplate: '%s | HCP Site',*/
            meta: [
                {
                    name: 'description', content: 'Learn about JORNAY PM (methylphenidate HCI), the first and only evening-dosed methylphenidate treatment that provides all-day ADHD symptom management. See Boxed Warning for full prescribing & safety info.'
                }
            ],
            link: [
                { rel: 'canonical', href: 'https://www.jornaypm-pro.com/' }
            ],
            script: [
                {
                vmid: 'ldjson-schema',
                innerHTML: `{
                    "@context": "http://schema.org",
                    "@type": "MedicalWebPage",
                    "audience": [
                    {
                        "@type": "MedicalAudience",
                        "audiencetype": "Healthcare Provider",
                        "mainContentOfPage": [
                            "JORNAY PM for ADHD Treatment"
                        ]
                    }
                    ],
                    "keywords": "jornay pm, jornay medication",
                    "name": "JORNAY PM",
                    "url": "https://www.jornaypm-pro.com/",
                    "description": "Learn about JORNAY PM (methylphenidate HCI), the first and only evening-dosed methylphenidate treatment that provides all-day ADHD symptom control. See Boxed Warning, Safety Info., and full Prescribing Information."
                }`,
                type: 'application/ld+json',
                body: false
                }
            ],
            __dangerouslyDisableSanitizersByTagID: {
                'ldjson-schema': ['innerHTML']
            }
        }
    }

    static pkPage() {
        return {
            title: 'Explore the PK Data for JORNAY PM (methylphenidate HCI)',
            meta: [
                {
                    name: 'description', content: 'See the PK data for JORNAY PM (methylphenidate HCI), to learn more about how long it lasts and the onset and offset of effect. See Boxed Warning for full prescribing & safety info.'
                }
            ],
            link: [
                { rel: 'canonical', href: 'https://www.jornaypm-pro.com/pk-data' }
            ],
            script: [
                {
                vmid: 'ldjson-schema',
                innerHTML: `{
                    "@context": "http://schema.org",
                    "@type": "MedicalWebPage",
                    "audience": [
                        {
                        "@type": "MedicalAudience",
                        "audiencetype": "Healthcare Provider",
                        "mainContentOfPage": ["PK Data"]
                        }
                    ],

                    "keywords": "jornay pm, jornay medication, jornay pm how long does it last",
                    "name": "JORNAY PM",
                    "url": "https://www.jornaypm-pro.com/pk-data",
                    "description": "See the PK data for JORNAY PM (methylphenidate HCI), to learn more about the onset and offset of effect. See Boxed Warning, Safety Info., and full Prescribing Information."
                }`,
                type: 'application/ld+json',
                body: false
                }
            ],
            __dangerouslyDisableSanitizersByTagID: {
                'ldjson-schema': ['innerHTML']
            }
        }
    }

    static doseDependentPage() {
        return {
            title: 'Dosage & Duration of Action for JORNAY PM (methylphenidate HCI)',
            meta: [
                {
                    name: 'description', content: 'Learn about dose-dependent duration with JORNAY PM (methylphenidate HCI), which allows all-day ADHD symptom management with one dose. See Boxed Warning for full prescribing & safety info.'
                }
            ],
            link: [
                { rel: 'canonical', href: 'https://www.jornaypm-pro.com/methylphenidate-dosage-duration' }
            ],
            script: [
                {
                vmid: 'ldjson-schema',
                innerHTML: `{
                    "@context": "http://schema.org",
                    "@type": "MedicalWebPage",
                    "audience": [
                        {
                        "@type": "MedicalAudience",
                        "audiencetype": "Healthcare Provider",
                        "mainContentOfPage": ["Methylphenidate Dosage Duration"]
                        }
                    ],

                    "keywords": "jornay pm, jornay medication, jornay pm duration of action, jornay starting dose, long acting methylphenidate products",
                    "name": "JORNAY PM",
                    "url": "https://www.jornaypm-pro.com/methylphenidate-dosage-duration",
                    "description": "Learn about data modeled for dose dependent duration of effect for JORNAY PM (methylphenidate HCI), which allows all-day ADHD symptom control with one dose. See Boxed Warning, Safety Info., and full Prescribing Information."
                }`,
                type: 'application/ld+json',
                body: false
                }
            ],
            __dangerouslyDisableSanitizersByTagID: {
                'ldjson-schema': ['innerHTML']
            }
        }
    }

    static dosingPage() {
        return {
            title: 'Explore Dosing Info for JORNAY PM (methylphenidate HCI)',
            meta: [
                {
                    name: 'description', content: 'JORNAY PM is the first & only evening-dosed medication that gives the flexibility of 5 dosage strengths to adjust the duration of ADHD symptom management. See Boxed Warning for full prescribing & safety info.'
                }
            ],
            link: [
                { rel: 'canonical', href: 'https://www.jornaypm-pro.com/dosing' }
            ],
            script: [
                {
                vmid: 'ldjson-schema',
                innerHTML: `{
                    "@context": "http://schema.org",
                    "@type": "MedicalWebPage",
                    "audience": [
                        {
                        "@type": "MedicalAudience",
                        "audiencetype": "Healthcare Provider",
                        "mainContentOfPage": ["JORNAY PM Dosing"]
                        }
                    ],

                    "keywords": "jornay pm, jornay medication, jornay dosing, jornay pm dosing",
                    "name": "JORNAY PM",
                    "url": "https://www.jornaypm-pro.com/dosing",
                    "description": "JORNAY PM is the first & only evening-dosed medication that gives the flexibility of 5 dosage strengths to adjust the duration of effect. See Boxed Warning, Safety Info., and full Prescribing Information."
                }`,
                type: 'application/ld+json',
                body: false
                }
            ],
            __dangerouslyDisableSanitizersByTagID: {
                'ldjson-schema': ['innerHTML']
            }
        }
    }

    static efficacyPage() {
        return {
            title: 'Explore Uses & Efficacy for JORNAY PM (methylphenidate HCI)',
            meta: [
                {
                    name: 'description', content: 'Learn about the efficacy and safety of JORNAY PM (methylphenidate HCI) that provides all-day ADHD symptom management. Read the clinical data. See Boxed Warning for full prescribing & safety info.'
                }
            ],
            link: [
                { rel: 'canonical', href: 'https://www.jornaypm-pro.com/adhd-medication-efficacy' }
            ],
            script: [
                {
                vmid: 'ldjson-schema',
                innerHTML: `{
                    "@context": "http://schema.org",
                    "@type": "MedicalWebPage",
                    "audience": [
                        {
                        "@type": "MedicalAudience",
                        "audiencetype": "Healthcare Provider",
                        "mainContentOfPage": ["JORNAY PM Efficacy"]
                        }
                    ],

                    "keywords": "jornay pm, jornay medication, jornay adhd, jornay adhd medication, jornay uses",
                    "name": "JORNAY PM",
                    "url": "https://www.jornaypm-pro.com/adhd-medication-efficacy",
                    "description": "Learn about the efficacy and safety of JORNAY PM (methylphenidate HCI) that studies demonstrated all-day ADHD symptom control. Read the clinical data. See Boxed Warning, Safety Info., and full Prescribing Information."
                }`,
                type: 'application/ld+json',
                body: false
                }
            ],
            __dangerouslyDisableSanitizersByTagID: {
                'ldjson-schema': ['innerHTML']
            }
        }
    }

    static safetyPage() {
        return {
            title: 'Learn Safety & Side Effects of JORNAY PM (methylphenidate HCI)',
            meta: [
                {
                    name: 'description', content: 'Read the safety profile for JORNAY PM (methylphenidate hydrochloride) to learn more about the side effects. See Boxed Warning for full prescribing & safety info.'
                }
            ],
            link: [
                { rel: 'canonical', href: 'https://www.jornaypm-pro.com/safety' }
            ],
            script: [
                {
                vmid: 'ldjson-schema',
                innerHTML: `{
                    "@context": "http://schema.org",
                    "@type": "MedicalWebPage",
                    "audience": [
                        {
                        "@type": "MedicalAudience",
                        "audiencetype": "Healthcare Provider",
                        "mainContentOfPage": ["JORNAY PM Safety & Side Effects"]
                        }
                    ],

                    "keywords": "jornay pm, jornay medication, jornay pm side effects, jornay side effects, is jornay a stimulant",
                    "name": "JORNAY PM",
                    "url": "https://www.jornaypm-pro.com/safety",
                    "description": "Read the safety profile for JORNAY PM (methylphenidate hydrochloride) to learn more about the side effects. See Boxed Warning, Safety Info., and full Prescribing Information."
                }`,
                type: 'application/ld+json',
                body: false
                }
            ],
            __dangerouslyDisableSanitizersByTagID: {
                'ldjson-schema': ['innerHTML']
            }
        }
    }

    static savingsPage() {
        return {
            title: 'Learn About Cost & Savings | JORNAY PM (methylphenidate HCI)',
            meta: [
                {
                    name: 'description', content: 'Find cost, savings options, and insurance resources, including Medicaid coverage, for Jornay PM (methylphenidate HCI). See Boxed Warning for full prescribing & safety info.'
                }
            ],
            link: [
                { rel: 'canonical', href: 'https://www.jornaypm-pro.com/savings' }
            ],
            script: [
                {
                vmid: 'ldjson-schema',
                innerHTML: `{
                    "@context": "http://schema.org",
                    "@type": "MedicalWebPage",
                    "audience": [
                        {
                        "@type": "MedicalAudience",
                        "audiencetype": "Healthcare Provider",
                        "mainContentOfPage": ["Cost & Patient Savings"]
                        }
                    ],

                    "keywords": "jornay pm, jornay medication, jornay pm cost, jornay pm savings card, jornay pm cost without insurance, is jornay pm covered by Medicaid, how much does jornay pm cost",
                    "name": "JORNAY PM",
                    "url": "https://www.jornaypm-pro.com/savings",
                    "description": "Find cost, savings options, and insurance resources, including Medicaid coverage, for Jornay PM (methylphenidate HCI). See Boxed Warning, Safety Info., and full Prescribing Information."
                }`,
                type: 'application/ld+json',
                body: false
                }
            ],
            __dangerouslyDisableSanitizersByTagID: {
                'ldjson-schema': ['innerHTML']
            }
        }
    }

    static resourcesPage() {
        return {
            title: 'ADHD Patient Resources | JORNAY PM (methylphenidate HCI)',
            meta: [
                {
                    name: 'description', content: 'Download resources for your ADHD patients to help them get started on JORNAY PM (methylphenidate hydrochloride). See Boxed Warning for full prescribing & safety info.'
                }
            ],
            link: [
                { rel: 'canonical', href: 'https://www.jornaypm-pro.com/resources' }
            ],
            script: [
                {
                vmid: 'ldjson-schema',
                innerHTML: `{
                    "@context": "http://schema.org",
                    "@type": "MedicalWebPage",
                    "audience": [
                        {
                        "@type": "MedicalAudience",
                        "audiencetype": "Healthcare Provider",
                        "mainContentOfPage": ["Patient Support & Resources"]
                        }
                    ],

                    "keywords": "jornay pm, jornay medication, jornay pm prescribing information",
                    "name": "JORNAY PM",
                    "url": "https://www.jornaypm-pro.com/resources",
                    "description": "Download resources for your ADHD patients to help them get started on JORNAY PM (methylphenidate hydrochloride). See Boxed Warning, Safety Info., and full Prescribing Information."
                }`,
                type: 'application/ld+json',
                body: false
                }
            ],
            __dangerouslyDisableSanitizersByTagID: {
                'ldjson-schema': ['innerHTML']
            }
        }
    }

    static thankYouPage() {
        return {
            title: 'Thank You',
            titleTemplate: '%s | JORNAY PM (methylphenidate hydrochloride)',
            meta: [
                {
                    name: 'description', content: 'We appreciate your interest in JORNAY PM and\n' +
                        'will honor your request for a visit with a\n' +
                        'representative and/or your request to receive\n' +
                        'email updates.'
                }
            ],
            link: [
                { rel: 'canonical', href: 'https://www.jornaypm-pro.com/thank-you' }
            ]
        }
    }

    static peerspectivesPage() {
        return {
            title: 'Explore PeerSpectives Videos | JORNAY PM (methylphenidate HCI)',
            meta: [
                {
                    name: 'description', content: 'Find informational video resources about Jornay PM (methylphenidate HCI) from physicians, specialists, and patients. See Boxed Warning for full prescribing & safety info.'
                }
            ],
            link: [
                { rel: 'canonical', href: 'https://www.jornaypm-pro.com/peerspectives' }
            ]
        }
    }

    static pricePage() {
        return {
            title: 'Price Information | JORNAY PM (methylphenidate hydrochloride)',
            meta: [
                {
                    name: 'description', content: 'Find JORNAY PM (methylphenidate hydrochloride) pricing information. Visit Jornaypm-pro.com for more information.'
                }
            ],
            link: [
                { rel: 'canonical', href: 'https://www.jornaypm-pro.com/Price_Disclosure' }
            ]
        }
    }

    static signUpPage() {
        return {
            title: 'Request More Information | JORNAY PM (methylphenidate HCI)',
            meta: [
                {
                    name: 'description', content: 'Sign up to receive more information on JORNAY PM (methylphenidate HCI) and how to get your patients started. See Boxed Warning for full prescribing & safety info.'
                }
            ],
            link: [
                { rel: 'canonical', href: 'https://www.jornaypm-pro.com/sign-up' }
            ],
            script: [
                {
                vmid: 'ldjson-schema',
                innerHTML: `{
                    "@context": "http://schema.org",
                    "@type": "MedicalWebPage",
                    "audience": [
                        {
                        "@type": "MedicalAudience",
                        "audiencetype": "Healthcare Provider",
                        "mainContentOfPage": ["Sign Up Form"]
                        }
                    ],

                    "keywords": "jornay pm, jornay medication, jornay adhd",
                    "name": "JORNAY PM",
                    "url": "https://www.jornaypm-pro.com/sign-up",
                    "description": "Sign up to receive more information on JORNAY PM (methylphenidate HCI) and how to get your patients started. See Boxed Warning, Safety Info., and full Prescribing Information."
                }`,
                type: 'application/ld+json',
                body: false
                }
            ],
            __dangerouslyDisableSanitizersByTagID: {
                'ldjson-schema': ['innerHTML']
            }
        }
    }
}
